import script from "./administra.vue?vue&type=script&setup=true&lang=js"
export * from "./administra.vue?vue&type=script&setup=true&lang=js"

import "./administra.vue?vue&type=style&index=0&id=9c29d6c6&lang=scss"

const __exports__ = script;

export default __exports__